import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_TITLE = 'MUNDOXYZ - Tu mundo de posibilidades';
const DEFAULT_DESCRIPTION = 'La plataforma de negocios digital más completa de Venezuela';
const DEFAULT_IMAGE = 'https://mundoxyz.com/logo_og.png';
const DEFAULT_URL = 'https://mundoxyz.com/';

const SeoHelmet = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url = DEFAULT_URL,
  type = 'website',
  canonical = url,
  noindex = false,
  keywords = ''
}) => {
  const fullTitle = title.includes('MUNDOXYZ') ? title : `${title} | MUNDOXYZ`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="MUNDOXYZ" />
      <meta property="og:locale" content="es_VE" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': type === 'product' ? 'Product' : 'WebSite',
          name: fullTitle,
          description,
          url: canonical,
          image
        })}
      </script>
    </Helmet>
  );
};

export default SeoHelmet;
